module.exports = __webpack_public_path__ + "img/express_lane.518c476c.svg";